@if (rateValue !== 0) {
  <span [ngClass]="rateClass" class="rounded bordered-none">
    {{ rateValue > 0 ? '+' : '-' }}{{ rateValue | abs | number:'1.0-2' }}%
  </span>
} @else {
  <span class="rounded bordered-none status-badge-text">0%</span>
}

